import { ModelBase, observable } from "@shoothill/core";
import { computed } from "mobx";
import moment from "moment";

export class ProjectVisitorsListModel extends ModelBase<ProjectVisitorsListModel> {
    public id: string = "";
    @observable public isSignIn: boolean = false;
    @observable public visitDate: string = "";
    @observable public visitorFullName: string = "";
    @observable public priorityEmployerName: string = "";
    @observable public lastThreePhoneDigits: string = "";
    @observable public visitorTypeName: string = "";
    @observable public ramsTitle: string = "";
    @observable public photographUrl: string = "";
    @observable public hasSignedOut: boolean = false;
    @observable public healthProblems: boolean = false;

    @computed
    public get visitDateFormatted() {
        return this.visitDate ? `${moment(this.visitDate).format("DD/MM/YYYY")} @ ${moment(this.visitDate).format("HH:mm")}` : "";
    }

    @computed
    public get healthProblemsFormatted() {
        return this.healthProblems ? "Y" : "N";
    }

    @computed
    public get lastThreePhoneDigitsFormatted() {
        return this.lastThreePhoneDigits.toString().padStart(3, "0");
    }

    constructor() {
        super();
    }

    fromDto(model: ProjectVisitorsListDTO): void {
        this.id = model.id;
        this.isSignIn = model.isSignIn;
        this.visitDate = model.visitDate;
        this.visitorFullName = model.visitorFullName;
        this.priorityEmployerName = model.priorityEmployerName;
        this.lastThreePhoneDigits = model.lastThreePhoneDigits;
        this.healthProblems = model.healthProblems;
        this.visitorTypeName = model.visitorTypeName;
        this.ramsTitle = model.ramsTitle;
        this.photographUrl = model.photographUrl;
        this.hasSignedOut = model.hasSignedOut;
    }
    toDto(model: ProjectVisitorsListModel): void {
        throw new Error("Method not implemented.");
    }
}

export interface ProjectVisitorsListDTO {
    id: string;
    isSignIn: boolean;
    visitDate: string;
    visitorFullName: string;
    priorityEmployerName: string;
    lastThreePhoneDigits: string;
    visitorTypeName: string;
    ramsTitle: string;
    photographUrl: string;
    hasSignedOut: boolean;
    healthProblems: boolean;
    isWorker: boolean;
}

export interface ProjectVisitorsListAndRelatedDTO {
    siteAccessItems: ProjectVisitorsListDTO[];
}

export interface ProjectVisitorsFormRequestDTO {
    date: string | null;
    projectId: string | null;
}
